// package: brokermanager
// file: broker-manager.proto

var broker_manager_pb = require("./broker-manager_pb");
var grpc = require("@improbable-eng/grpc-web").grpc;

var BrokerManager = (function () {
  function BrokerManager() {}
  BrokerManager.serviceName = "brokermanager.BrokerManager";
  return BrokerManager;
}());

BrokerManager.ListBrokers = {
  methodName: "ListBrokers",
  service: BrokerManager,
  requestStream: false,
  responseStream: false,
  requestType: broker_manager_pb.ListBrokersReq,
  responseType: broker_manager_pb.ListBrokerReply
};

BrokerManager.GetBrokerInfo = {
  methodName: "GetBrokerInfo",
  service: BrokerManager,
  requestStream: false,
  responseStream: false,
  requestType: broker_manager_pb.GetBrokerInfoReq,
  responseType: broker_manager_pb.GetBrokerInfoReply
};

BrokerManager.AddBroker = {
  methodName: "AddBroker",
  service: BrokerManager,
  requestStream: false,
  responseStream: false,
  requestType: broker_manager_pb.AddBrokerReq,
  responseType: broker_manager_pb.AddBrokerReply
};

BrokerManager.UpdateBroker = {
  methodName: "UpdateBroker",
  service: BrokerManager,
  requestStream: false,
  responseStream: false,
  requestType: broker_manager_pb.UpdateBrokerReq,
  responseType: broker_manager_pb.UpdateBrokerReply
};

BrokerManager.DeleteBroker = {
  methodName: "DeleteBroker",
  service: BrokerManager,
  requestStream: false,
  responseStream: false,
  requestType: broker_manager_pb.DeleteBrokerReq,
  responseType: broker_manager_pb.DeleteBrokerReply
};

BrokerManager.AdminGetServersInfo = {
  methodName: "AdminGetServersInfo",
  service: BrokerManager,
  requestStream: false,
  responseStream: false,
  requestType: broker_manager_pb.AdminGetServersInfoReq,
  responseType: broker_manager_pb.AdminGetServersInfoReply
};

BrokerManager.AdminPingHostMany = {
  methodName: "AdminPingHostMany",
  service: BrokerManager,
  requestStream: false,
  responseStream: false,
  requestType: broker_manager_pb.AdminPingHostManyReq,
  responseType: broker_manager_pb.AdminPingHostManyReply
};

BrokerManager.AdminChangeServerAccountsConnectionType = {
  methodName: "AdminChangeServerAccountsConnectionType",
  service: BrokerManager,
  requestStream: false,
  responseStream: false,
  requestType: broker_manager_pb.AdminChangeServerAccountsConnectionTypeReq,
  responseType: broker_manager_pb.AdminChangeServerAccountsConnectionTypeReply
};

BrokerManager.AdminChangeBrokerAccountsConnectionType = {
  methodName: "AdminChangeBrokerAccountsConnectionType",
  service: BrokerManager,
  requestStream: false,
  responseStream: false,
  requestType: broker_manager_pb.AdminChangeBrokerAccountsConnectionTypeReq,
  responseType: broker_manager_pb.AdminChangeBrokerAccountsConnectionTypeReply
};

BrokerManager.AddServer = {
  methodName: "AddServer",
  service: BrokerManager,
  requestStream: false,
  responseStream: false,
  requestType: broker_manager_pb.AddServerReq,
  responseType: broker_manager_pb.AddServerReply
};

BrokerManager.AdminUpdateServer = {
  methodName: "AdminUpdateServer",
  service: BrokerManager,
  requestStream: false,
  responseStream: false,
  requestType: broker_manager_pb.AdminUpdateServerReq,
  responseType: broker_manager_pb.AdminUpdateServerReply
};

BrokerManager.AdminUpdateServerIP = {
  methodName: "AdminUpdateServerIP",
  service: BrokerManager,
  requestStream: false,
  responseStream: false,
  requestType: broker_manager_pb.AdminUpdateServerIPReq,
  responseType: broker_manager_pb.AdminUpdateServerIPReply
};

BrokerManager.DeleteServer = {
  methodName: "DeleteServer",
  service: BrokerManager,
  requestStream: false,
  responseStream: false,
  requestType: broker_manager_pb.DeleteServerReq,
  responseType: broker_manager_pb.DeleteServerReply
};

BrokerManager.GetServerInfo = {
  methodName: "GetServerInfo",
  service: BrokerManager,
  requestStream: false,
  responseStream: false,
  requestType: broker_manager_pb.GetServerInfoReq,
  responseType: broker_manager_pb.GetServerInfoReply
};

BrokerManager.GetServerInfoMany = {
  methodName: "GetServerInfoMany",
  service: BrokerManager,
  requestStream: false,
  responseStream: false,
  requestType: broker_manager_pb.GetServerInfoManyReq,
  responseType: broker_manager_pb.GetServerInfoManyReply
};

BrokerManager.SearchBroker = {
  methodName: "SearchBroker",
  service: BrokerManager,
  requestStream: false,
  responseStream: false,
  requestType: broker_manager_pb.SearchBrokerReq,
  responseType: broker_manager_pb.SearchBrokerRely
};

BrokerManager.AdminAddServerIP = {
  methodName: "AdminAddServerIP",
  service: BrokerManager,
  requestStream: false,
  responseStream: false,
  requestType: broker_manager_pb.AdminAddServerIPReq,
  responseType: broker_manager_pb.AdminAddServerIPReply
};

BrokerManager.AdminReorderServerIPs = {
  methodName: "AdminReorderServerIPs",
  service: BrokerManager,
  requestStream: false,
  responseStream: false,
  requestType: broker_manager_pb.AdminReorderServerIPsReq,
  responseType: broker_manager_pb.AdminReorderServerIPsReply
};

BrokerManager.AdminGetServerIPs = {
  methodName: "AdminGetServerIPs",
  service: BrokerManager,
  requestStream: false,
  responseStream: false,
  requestType: broker_manager_pb.AdminGetServerIPsReq,
  responseType: broker_manager_pb.AdminGetServerIPsReply
};

BrokerManager.AdminDeleteServerIP = {
  methodName: "AdminDeleteServerIP",
  service: BrokerManager,
  requestStream: false,
  responseStream: false,
  requestType: broker_manager_pb.AdminDeleteServerIPReq,
  responseType: broker_manager_pb.AdminDeleteServerIPReply
};

exports.BrokerManager = BrokerManager;

function BrokerManagerClient(serviceHost, options) {
  this.serviceHost = serviceHost;
  this.options = options || {};
}

BrokerManagerClient.prototype.listBrokers = function listBrokers(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(BrokerManager.ListBrokers, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

BrokerManagerClient.prototype.getBrokerInfo = function getBrokerInfo(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(BrokerManager.GetBrokerInfo, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

BrokerManagerClient.prototype.addBroker = function addBroker(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(BrokerManager.AddBroker, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

BrokerManagerClient.prototype.updateBroker = function updateBroker(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(BrokerManager.UpdateBroker, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

BrokerManagerClient.prototype.deleteBroker = function deleteBroker(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(BrokerManager.DeleteBroker, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

BrokerManagerClient.prototype.adminGetServersInfo = function adminGetServersInfo(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(BrokerManager.AdminGetServersInfo, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

BrokerManagerClient.prototype.adminPingHostMany = function adminPingHostMany(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(BrokerManager.AdminPingHostMany, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

BrokerManagerClient.prototype.adminChangeServerAccountsConnectionType = function adminChangeServerAccountsConnectionType(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(BrokerManager.AdminChangeServerAccountsConnectionType, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

BrokerManagerClient.prototype.adminChangeBrokerAccountsConnectionType = function adminChangeBrokerAccountsConnectionType(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(BrokerManager.AdminChangeBrokerAccountsConnectionType, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

BrokerManagerClient.prototype.addServer = function addServer(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(BrokerManager.AddServer, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

BrokerManagerClient.prototype.adminUpdateServer = function adminUpdateServer(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(BrokerManager.AdminUpdateServer, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

BrokerManagerClient.prototype.adminUpdateServerIP = function adminUpdateServerIP(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(BrokerManager.AdminUpdateServerIP, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

BrokerManagerClient.prototype.deleteServer = function deleteServer(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(BrokerManager.DeleteServer, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

BrokerManagerClient.prototype.getServerInfo = function getServerInfo(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(BrokerManager.GetServerInfo, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

BrokerManagerClient.prototype.getServerInfoMany = function getServerInfoMany(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(BrokerManager.GetServerInfoMany, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

BrokerManagerClient.prototype.searchBroker = function searchBroker(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(BrokerManager.SearchBroker, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

BrokerManagerClient.prototype.adminAddServerIP = function adminAddServerIP(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(BrokerManager.AdminAddServerIP, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

BrokerManagerClient.prototype.adminReorderServerIPs = function adminReorderServerIPs(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(BrokerManager.AdminReorderServerIPs, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

BrokerManagerClient.prototype.adminGetServerIPs = function adminGetServerIPs(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(BrokerManager.AdminGetServerIPs, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

BrokerManagerClient.prototype.adminDeleteServerIP = function adminDeleteServerIP(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(BrokerManager.AdminDeleteServerIP, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

exports.BrokerManagerClient = BrokerManagerClient;

var Internal = (function () {
  function Internal() {}
  Internal.serviceName = "brokermanager.Internal";
  return Internal;
}());

Internal.IntGetBrokerInfoByName = {
  methodName: "IntGetBrokerInfoByName",
  service: Internal,
  requestStream: false,
  responseStream: false,
  requestType: broker_manager_pb.IntGetBrokerInfoByNameReq,
  responseType: broker_manager_pb.IntGetBrokerInfoByNameReply
};

Internal.IntBrokerServerInfo = {
  methodName: "IntBrokerServerInfo",
  service: Internal,
  requestStream: false,
  responseStream: false,
  requestType: broker_manager_pb.IntBrokerServerInfoReq,
  responseType: broker_manager_pb.IntBrokerServerInfoReply
};

Internal.IntBrokerServersIPMapInfo = {
  methodName: "IntBrokerServersIPMapInfo",
  service: Internal,
  requestStream: false,
  responseStream: false,
  requestType: broker_manager_pb.IntBrokerServersIPMapInfoReq,
  responseType: broker_manager_pb.IntBrokerServersIPMapInfoReply
};

Internal.IntGetServersBaseSymbols = {
  methodName: "IntGetServersBaseSymbols",
  service: Internal,
  requestStream: false,
  responseStream: false,
  requestType: broker_manager_pb.IntGetServersBaseSymbolsReq,
  responseType: broker_manager_pb.IntGetServersBaseSymbolsReply
};

exports.Internal = Internal;

function InternalClient(serviceHost, options) {
  this.serviceHost = serviceHost;
  this.options = options || {};
}

InternalClient.prototype.intGetBrokerInfoByName = function intGetBrokerInfoByName(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Internal.IntGetBrokerInfoByName, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

InternalClient.prototype.intBrokerServerInfo = function intBrokerServerInfo(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Internal.IntBrokerServerInfo, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

InternalClient.prototype.intBrokerServersIPMapInfo = function intBrokerServersIPMapInfo(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Internal.IntBrokerServersIPMapInfo, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

InternalClient.prototype.intGetServersBaseSymbols = function intGetServersBaseSymbols(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Internal.IntGetServersBaseSymbols, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

exports.InternalClient = InternalClient;

